export const siteInfo = {
  name: "黑料入口",
  corePositioning: "全网吃瓜爆料第一线",
  slogan: "51吃瓜黑料入口一二三 · 免费黑料入口直达 · 瓜农独家一线新瓜速递",
};

export const navLinks = [
  { label: "首页", href: "#hero" },
  { label: "实时快讯", href: "#updates" },
  { label: "专题索引", href: "#index" },
  { label: "关于我们", href: "#about" },
  { label: "读者热议", href: "#comments" },
];

export const heroStats = [
  { label: "日均更新", value: "200+ 条", icon: "ri-flashlight-line" },
  { label: "独家爆料", value: "5000+ 篇", icon: "ri-fire-line" },
  { label: "7×24小时", value: "实时追踪", icon: "ri-time-line" },
];

export const cards = [
  {
    id: 1,
    title: "某顶流男星深夜密会神秘女子，酒店同框照流出",
    summary: "据一线瓜农爆料，某当红顶流男星近日被拍到深夜与一名神秘女子先后进入某五星级酒店，两人刻意分开行动但被蹲守摄影师捕捉到同框画面。",
    tag: "独家爆料",
    time: "2小时前",
    views: "128.6万",
    image: "https://readdy.ai/api/search-image?query=Chinese%20entertainment%20news%20paparazzi%20style%20photo%20of%20celebrity%20entering%20luxury%20hotel%20at%20night%2C%20dramatic%20lighting%2C%20dark%20atmosphere%2C%20editorial%20photography%2C%20warm%20street%20lights%2C%20mysterious%20mood&width=800&height=500&seq=card-01&orientation=landscape",
  },
  {
    id: 2,
    title: "某综艺节目录制现场爆发激烈冲突，导演组紧急叫停",
    summary: "知情人士透露，在某热门综艺最新一期录制过程中，两位常驻嘉宾因游戏环节产生严重分歧，现场气氛一度剑拔弩张，导演组不得不临时中断录制进行调解。",
    tag: "现场直击",
    time: "5小时前",
    views: "96.3万",
    image: "https://readdy.ai/api/search-image?query=Chinese%20TV%20variety%20show%20recording%20studio%20set%20with%20bright%20stage%20lights%20and%20cameras%2C%20dramatic%20atmosphere%2C%20behind%20the%20scenes%20look%2C%20professional%20photography%2C%20warm%20studio%20lighting&width=800&height=500&seq=card-02&orientation=landscape",
  },
  {
    id: 3,
    title: "知名导演新片选角内幕曝光，某小花靠关系上位",
    summary: "圈内人士匿名爆料称，某知名导演筹备多年的新片女主角人选历经多轮角逐，最终花落一位资历尚浅的小花，背后疑似有资本力量推动，引发业内热议。",
    tag: "深度揭秘",
    time: "8小时前",
    views: "215.7万",
    image: "https://readdy.ai/api/search-image?query=Chinese%20film%20audition%20scene%20with%20director%20chair%20and%20camera%20equipment%20on%20set%2C%20cinematic%20lighting%2C%20dramatic%20mood%2C%20professional%20film%20production%20atmosphere%2C%20warm%20tones&width=800&height=500&seq=card-03&orientation=landscape",
  },
  {
    id: 4,
    title: "某女星与前经纪公司解约纠纷升级，千万违约金曝光",
    summary: "近日某知名女星与老东家的解约纠纷持续发酵，一份疑似内部合同文件显示违约金高达数千万元，双方各执一词，粉丝站队引发新一轮网络论战。",
    tag: "跟踪报道",
    time: "12小时前",
    views: "187.2万",
    image: "https://readdy.ai/api/search-image?query=Chinese%20entertainment%20industry%20legal%20dispute%20concept%20with%20contract%20documents%20on%20desk%2C%20dramatic%20office%20lighting%2C%20serious%20atmosphere%2C%20editorial%20style%2C%20warm%20ambient%20light&width=800&height=500&seq=card-04&orientation=landscape",
  },
  {
    id: 5,
    title: "某直播平台头部主播偷税案细节披露，涉及金额惊人",
    summary: "税务部门最新通报显示，某直播平台知名头部主播涉嫌通过多种方式偷逃税款，涉及金额之大令行业震惊，目前该主播所有社交账号已被暂停使用。",
    tag: "重磅消息",
    time: "1天前",
    views: "352.9万",
    image: "https://readdy.ai/api/search-image?query=Chinese%20live%20streaming%20studio%20setup%20with%20ring%20light%20and%20professional%20equipment%2C%20empty%20streamer%20chair%2C%20dark%20dramatic%20atmosphere%2C%20news%20investigation%20style%2C%20warm%20contrast%20lighting&width=800&height=500&seq=card-05&orientation=landscape",
  },
  {
    id: 6,
    title: "年度最受期待影视剧定档，主演阵容意外大换血",
    summary: "备受观众期待的年度大剧终于官宣定档，然而公布的主演名单与此前传闻大相径庭，三位原定主演被替换，片方给出的解释引发粉丝强烈不满。",
    tag: "独家首发",
    time: "1天前",
    views: "276.4万",
    image: "https://readdy.ai/api/search-image?query=Chinese%20film%20premiere%20red%20carpet%20event%20poster%20display%20with%20dramatic%20lighting%2C%20cinematic%20atmosphere%2C%20theater%20entrance%2C%20movie%20promotion%20vibe%2C%20warm%20golden%20accents&width=800&height=500&seq=card-06&orientation=landscape",
  },
];

export const comments = [
  {
    id: 1,
    avatar: "https://readdy.ai/api/search-image?query=Chinese%20young%20person%20casual%20portrait%20photo%2C%20natural%20lighting%2C%20simple%20background%2C%20editorial%20style%2C%20warm%20tones%2C%20clean%20aesthetic&width=120&height=120&seq=avatar-01&orientation=squarish",
    nickname: "吃瓜一线猹",
    time: "3分钟前",
    content: "这个瓜我蹲了好久终于有人爆出来了！之前就在圈内听说过风声，没想到实锤这么猛，坐等后续反转。",
    likes: 2836,
  },
  {
    id: 2,
    avatar: "https://readdy.ai/api/search-image?query=Asian%20young%20woman%20portrait%20photo%2C%20natural%20lighting%2C%20simple%20warm%20background%2C%20editorial%20style%2C%20casual%20look%2C%20clean%20aesthetic&width=120&height=120&seq=avatar-02&orientation=squarish",
    nickname: "八卦探测器",
    time: "15分钟前",
    content: "对比了一下时间线，发现当事人之前发的那条微博其实就是在暗示这件事，只是当时没人看懂。",
    likes: 1652,
  },
  {
    id: 3,
    avatar: "https://readdy.ai/api/search-image?query=Young%20Chinese%20person%20portrait%20with%20glasses%2C%20natural%20indoor%20lighting%2C%20simple%20background%2C%20editorial%20style%2C%20warm%20tones%2C%20intellectual%20look&width=120&height=120&seq=avatar-03&orientation=squarish",
    nickname: "内娱档案馆",
    time: "28分钟前",
    content: "整理了一份完整的事件时间线，从三年前的那次合作就开始有苗头了，细思极恐。都是圈内老人了，懂的都懂。",
    likes: 3419,
  },
  {
    id: 4,
    avatar: "https://readdy.ai/api/search-image?query=Asian%20person%20casual%20portrait%20photo%2C%20outdoor%20natural%20lighting%2C%20simple%20warm%20background%2C%20editorial%20style%2C%20friendly%20expression%2C%20clean%20aesthetic&width=120&height=120&seq=avatar-04&orientation=squarish",
    nickname: "猹田守望者",
    time: "42分钟前",
    content: "哈哈哈哈评论区比正文还精彩，建议黑料入口开个评论区精选专栏，各路大神分析得头头是道。",
    likes: 920,
  },
];

export const indexItems = [
  { id: 1, title: "顶流明星专区", desc: "追踪一线顶流的最新动态与独家爆料", count: "328篇", icon: "ri-star-line", color: "primary" },
  { id: 2, title: "综艺节目内幕", desc: "热门综艺录制现场的幕后真实故事", count: "215篇", icon: "ri-tv-line", color: "accent" },
  { id: 3, title: "影视剧爆料", desc: "新剧选角、剧组趣闻与行业潜规则", count: "192篇", icon: "ri-film-line", color: "primary" },
  { id: 4, title: "直播圈风向", desc: "头部主播动态、平台博弈与行业监管", count: "167篇", icon: "ri-live-line", color: "accent" },
  { id: 5, title: "音乐圈秘闻", desc: "歌手合约、演唱会幕后与版权争夺", count: "143篇", icon: "ri-music-line", color: "primary" },
  { id: 6, title: "体育圈吃瓜", desc: "运动员场外生活、转会内幕与商业代言", count: "118篇", icon: "ri-basketball-line", color: "accent" },
  { id: 7, title: "网红界风云", desc: "短视频达人起落、MCN机构与流量密码", count: "256篇", icon: "ri-user-smile-line", color: "primary" },
];

export const aboutContent = {
  title: "关于黑料入口",
  paragraphs: [
    "黑料入口成立于2019年，是国内领先的娱乐资讯聚合与独家爆料平台，致力于为广大吃瓜群众提供最新、最全、最热的一手黑料资讯。我们汇聚了来自大江南北的资深瓜农，以「真实、快速、深度」为核心理念，打造覆盖51吃瓜黑料入口一二三、免费黑料入口等多个渠道的娱乐信息网络。",
    "平台每天更新超过200条独家内容，拥有5000余篇原创深度爆料，涵盖明星八卦、综艺内幕、影视动态、直播风向、音乐圈秘闻等多个领域。我们的瓜农团队深入娱乐产业一线，从现场直击到幕后追踪，从合同纠纷到资本博弈，每一篇爆料都经过多源交叉验证。",
    "黑料入口始终坚持为读者提供免费、快捷的黑料获取通道。无论是网页端、移动端还是社交媒体，我们都建立了完善的内容分发体系，确保每位吃瓜爱好者都能第一时间获取最新瓜讯。不站队、不恰饭、不删帖——这是我们与读者之间的默契。",
  ],
};

export const appContent = {
  title: "黑料入口 · 随时随地吃瓜",
  tagline: "扫码下载黑料入口APP，第一时间获取独家爆料推送",
  features: ["实时推送 · 新瓜秒达", "独家内容 · 全网首发", "社区互动 · 一起吃瓜", "免广告体验 · 流畅阅读"],
  qrCodeImage: "https://readdy.ai/api/search-image?query=Minimalist%20QR%20code%20design%20with%20dark%20geometric%20pattern%20on%20clean%20white%20background%2C%20modern%20tech%20aesthetic%2C%20high%20contrast%2C%20simple%20and%20elegant&width=400&height=400&seq=qr-code&orientation=squarish",
  previewImage: "https://readdy.ai/api/search-image?query=Chinese%20mobile%20news%20app%20interface%20design%20mockup%20showing%20entertainment%20gossip%20feed%2C%20dark%20theme%20UI%2C%20modern%20smartphone%20screen%2C%20clean%20typography%2C%20editorial%20news%20layout%2C%20warm%20accent%20colors%2C%20professional%20app%20screenshot&width=600&height=900&seq=app-preview&orientation=portrait",
};

export const contactContent = {
  title: "联系我们 · 爆料投稿",
  intro: "你有独家线索？发现不为人知的内幕？黑料入口欢迎每一位瓜农和知情人士投稿爆料，我们为每一位爆料人提供严格的隐私保护。",
  items: [
    { icon: "ri-mail-line", label: "爆料邮箱", value: "tips@heimoru.com" },
    { icon: "ri-wechat-line", label: "微信爆料", value: "heiliaotougao" },
    { icon: "ri-shield-check-line", label: "隐私承诺", value: "严格保护爆料人信息" },
  ],
};

export const faqItems = [
  {
    id: 1,
    question: "黑料入口的爆料内容可靠吗？",
    answer: "黑料入口所有内容均来自资深瓜农一线采集和独家渠道，每一条爆料在发布前都经过多源交叉验证。我们坚持「求证优先于速度」的编辑原则，对于无法核实的信息会明确标注「传闻」标签，让读者自行判断。同时我们保留对不实信息的更正和撤稿机制。",
  },
  {
    id: 2,
    question: "如何向黑料入口投稿爆料？",
    answer: "您可以通过页面底部的联系方式发送邮件至 tips@heimoru.com，或添加微信 heiliaotougao 进行投稿。我们承诺对每一位爆料人的身份信息严格保密，采用端到端加密通信。对于重要独家线索，我们会安排专人对接并给予相应报酬。",
  },
  {
    id: 3,
    question: "51吃瓜黑料入口一二三是什么意思？",
    answer: "51吃瓜黑料入口一二三是黑料入口为方便读者记忆和访问而设立的多线路入口体系。「一二三」代表我们提供了多条独立的内容访问通道，即使某个入口因访问量过大或其他原因暂时拥堵，读者也可以通过其他入口顺畅访问，确保随时随地都能吃到最新鲜的瓜。",
  },
  {
    id: 4,
    question: "黑料入口的内容是否收费？",
    answer: "黑料入口始终坚持免费开放的内容策略，所有爆料资讯、专题报道和独家内容均可免费阅读。我们通过品牌合作和广告投放维持平台运营，绝不会对核心内容设置付费墙。我们的使命是让每一位吃瓜爱好者都能平等、便捷地获取第一手娱乐资讯。",
  },
];

export const updates = [
  {
    id: 1,
    time: "10分钟前",
    title: "某知名导演新片片场发生意外，拍摄暂停",
    summary: "据现场工作人员透露，事故原因正在调查中，暂无人员伤亡报告。",
    tag: "突发",
    icon: "ri-alert-line",
  },
  {
    id: 2,
    time: "25分钟前",
    title: "某女星工作室凌晨发文辟谣恋情传闻",
    summary: "工作室声明称网传照片为剧组工作照，将追究造谣者法律责任。",
    tag: "辟谣",
    icon: "ri-file-text-line",
  },
  {
    id: 3,
    time: "1小时前",
    title: "热门网剧第二季官宣开机，原班人马全员回归",
    summary: "制片方在开机仪式上确认所有主要演员均已签约，制作预算翻倍。",
    tag: "官宣",
    icon: "ri-megaphone-line",
  },
  {
    id: 4,
    time: "3小时前",
    title: "某选秀节目选手名单遭泄露，节目组紧急回应",
    summary: "泄露名单中包含多位已签约经纪公司的练习生，节目组表示将追究泄密者。",
    tag: "泄露",
    icon: "ri-lock-unlock-line",
  },
  {
    id: 5,
    time: "6小时前",
    title: "知名音乐人新专辑延期发行，疑似与版权纠纷有关",
    summary: "多位业内人士证实专辑母带已完成，但因版权归属问题被暂时冻结。",
    tag: "内幕",
    icon: "ri-disc-line",
  },
  {
    id: 6,
    time: "9小时前",
    title: "某品牌代言人突然更换，原代言人粉丝集体抗议",
    summary: "品牌方未说明更换原因，新代言人社交媒体评论区已被粉丝攻占。",
    tag: "争议",
    icon: "ri-swap-line",
  },
  {
    id: 7,
    time: "12小时前",
    title: "年度娱乐盛典提名名单公布，多匹黑马入围引热议",
    summary: "多位新人演员首次入围重量级奖项，业内人士称本届竞争最为激烈。",
    tag: "热点",
    icon: "ri-award-line",
  },
];

export const rankingItems = [
  { id: 1, rank: 1, title: "顶流男星深夜密会神秘女子", heat: "1286万热度", trend: "up", change: "+320万" },
  { id: 2, rank: 2, title: "知名导演新片选角内幕大曝光", heat: "1052万热度", trend: "up", change: "+215万" },
  { id: 3, rank: 3, title: "头部主播偷税案细节持续披露", heat: "987万热度", trend: "up", change: "+198万" },
  { id: 4, rank: 4, title: "年度大剧定档主演阵容大换血", heat: "873万热度", trend: "down", change: "-56万" },
  { id: 5, rank: 5, title: "综艺录制现场嘉宾冲突事件", heat: "761万热度", trend: "up", change: "+142万" },
  { id: 6, rank: 6, title: "女星解约纠纷千万违约金内情", heat: "698万热度", trend: "stable", change: "持平" },
  { id: 7, rank: 7, title: "直播平台新一轮监管政策出台", heat: "634万热度", trend: "up", change: "+89万" },
];

export const topicTags = [
  { id: 1, name: "顶流八卦", count: "2.8万讨论", hot: true },
  { id: 2, name: "综艺翻车", count: "1.6万讨论", hot: true },
  { id: 3, name: "影视内幕", count: "2.1万讨论", hot: false },
  { id: 4, name: "解约风波", count: "1.3万讨论", hot: true },
  { id: 5, name: "偷税漏税", count: "3.5万讨论", hot: true },
  { id: 6, name: "选角黑幕", count: "9800讨论", hot: false },
  { id: 7, name: "品牌翻车", count: "1.1万讨论", hot: false },
  { id: 8, name: "恋情实锤", count: "2.3万讨论", hot: true },
  { id: 9, name: "直播圈风向", count: "1.8万讨论", hot: false },
  { id: 10, name: "音乐圈秘闻", count: "7600讨论", hot: false },
  { id: 11, name: "网红界风云", count: "1.5万讨论", hot: true },
];

export const carouselItems = [
  {
    id: 1,
    title: "年度十大反转瓜：那些打脸的瞬间",
    summary: "盘点本年度最具戏剧性的爆料反转事件，从全民声讨到真相大白……",
    tag: "年度策划",
    image: "https://readdy.ai/api/search-image?query=Dramatic%20Chinese%20entertainment%20news%20visual%20with%20newspaper%20headlines%20and%20spotlight%20effect%2C%20editorial%20design%20style%2C%20warm%20dramatic%20lighting%2C%20bold%20typography%2C%20newsroom%20atmosphere&width=900&height=500&seq=carousel-01&orientation=landscape",
  },
  {
    id: 2,
    title: "从素人到顶流：娱乐圈生存法则深度解析",
    summary: "揭秘娱乐圈金字塔背后的资本运作、人脉网络与生存法则……",
    tag: "深度报道",
    image: "https://readdy.ai/api/search-image?query=Chinese%20entertainment%20industry%20behind%20the%20scenes%20with%20stage%20spotlights%20and%20silhouettes%2C%20dramatic%20cinematic%20lighting%2C%20curtains%20opening%2C%20theater%20atmosphere%2C%20warm%20golden%20tones&width=900&height=500&seq=carousel-02&orientation=landscape",
  },
  {
    id: 3,
    title: "瓜农生存报告：一线爆料人的日常与风险",
    summary: "走进狗仔与瓜农的真实世界，了解每一篇爆料背后的付出与代价……",
    tag: "幕后故事",
    image: "https://readdy.ai/api/search-image?query=Investigative%20journalist%20workspace%20with%20camera%20equipment%20and%20notes%20on%20desk%2C%20dramatic%20lighting%2C%20documentary%20style%2C%20warm%20atmospheric%20light%2C%20professional%20photography%20gear&width=900&height=500&seq=carousel-03&orientation=landscape",
  },
  {
    id: 4,
    title: "娱乐圈法律援助指南：艺人合约纠纷全解析",
    summary: "专业律师解读艺人合约中的常见陷阱与维权路径……",
    tag: "行业观察",
    image: "https://readdy.ai/api/search-image?query=Legal%20documents%20and%20contracts%20on%20a%20professional%20desk%20with%20warm%20lighting%2C%20law%20books%20in%20background%2C%20Chinese%20legal%20professional%20setting%2C%20editorial%20style%2C%20clean%20composition&width=900&height=500&seq=carousel-04&orientation=landscape",
  },
  {
    id: 5,
    title: "2025娱乐产业白皮书：数据背后的真相",
    summary: "透过数据看行业——从票房、收视率到代言费用，全面解读产业趋势……",
    tag: "数据分析",
    image: "https://readdy.ai/api/search-image?query=Data%20analytics%20dashboard%20with%20charts%20and%20graphs%20showing%20entertainment%20industry%20statistics%2C%20modern%20office%20setting%2C%20warm%20professional%20lighting%2C%20clean%20design%2C%20infographic%20style&width=900&height=500&seq=carousel-05&orientation=landscape",
  },
  {
    id: 6,
    title: "黑料之外：那些被忽视的行业正能量",
    summary: "在八卦与爆料之外，娱乐圈也有不少温暖人心的故事值得被看见……",
    tag: "特别企划",
    image: "https://readdy.ai/api/search-image?query=Warm%20and%20uplifting%20Chinese%20entertainment%20scene%20with%20soft%20golden%20backlight%2C%20hopeful%20atmosphere%2C%20cinematic%20quality%2C%20backstage%20warm%20lighting%2C%20positive%20energy%2C%20beautiful%20composition&width=900&height=500&seq=carousel-06&orientation=landscape",
  },
];

export const featureItems = [
  {
    id: 1,
    icon: "ri-flashlight-line",
    title: "一线直击",
    desc: "瓜农深入娱乐圈一线，从综艺录制现场到明星私人行程，为你带来第一手独家画面与实时报道。",
  },
  {
    id: 2,
    icon: "ri-shield-check-line",
    title: "多源验证",
    desc: "每一条爆料均经过至少两个独立信息源的交叉核实，标注可信度等级，让吃瓜更有依据。",
  },
  {
    id: 3,
    icon: "ri-rocket-line",
    title: "极速更新",
    desc: "7×24小时全天候追踪娱乐动态，重大事件发生后15分钟内完成首报，不让瓜友多等一秒。",
  },
  {
    id: 4,
    icon: "ri-global-line",
    title: "多入口直达",
    desc: "覆盖51吃瓜黑料入口一二三、免费黑料入口等多条直达通道，确保在任何网络环境下都能顺畅访问。",
  },
  {
    id: 5,
    icon: "ri-user-heart-line",
    title: "读者至上",
    desc: "不站队、不恰饭、不删帖，坚持为读者提供纯粹的吃瓜体验，所有的报道只对真相和读者负责。",
  },
];

export const mediaItems = [
  {
    id: 1,
    title: "独家对话：一位退圈狗仔的十年自述",
    duration: "45:22",
    views: "328.5万",
    image: "https://readdy.ai/api/search-image?query=Interview%20scene%20with%20silhouetted%20figure%20in%20front%20of%20camera%2C%20documentary%20film%20style%2C%20dramatic%20lighting%2C%20warm%20atmosphere%2C%20professional%20video%20production%2C%20cinematic%20quality&width=800&height=450&seq=media-01&orientation=landscape",
  },
  {
    id: 2,
    title: "娱乐圈资本局：谁在幕后操控流量",
    duration: "32:18",
    views: "256.7万",
    image: "https://readdy.ai/api/search-image?query=Business%20meeting%20room%20with%20stock%20market%20data%20on%20screen%2C%20entertainment%20industry%20concept%2C%20dramatic%20corporate%20lighting%2C%20modern%20office%2C%20warm%20professional%20atmosphere&width=800&height=450&seq=media-02&orientation=landscape",
  },
  {
    id: 3,
    title: "新瓜速递：本周最值得关注的五条线索",
    duration: "18:45",
    views: "189.3万",
    image: "https://readdy.ai/api/search-image?query=News%20studio%20desk%20with%20multiple%20monitors%20displaying%20entertainment%20headlines%2C%20modern%20broadcast%20setup%2C%20warm%20professional%20lighting%2C%20clean%20composition%2C%20editorial%20vibe&width=800&height=450&seq=media-03&orientation=landscape",
  },
];

export const footerLinks = [
  { label: "关于我们", href: "#about" },
  { label: "联系我们", href: "#contact" },
  { label: "常见问题", href: "#faq" },
  { label: "专题索引", href: "#index" },
  { label: "实时快讯", href: "#updates" },
  { label: "热度排行", href: "#ranking" },
];

export const footerIntro = "黑料入口是国内领先的娱乐资讯聚合与独家爆料平台，覆盖51吃瓜黑料入口一二三、免费黑料入口等多条直达通道，汇聚全网最全最新的黑料爆料、新瓜速递与独家一线现场报道。致力于为广大吃瓜群众提供真实、快速、深度的吃瓜体验。";